import { color } from "src/styles/globals";
import styled from "styled-components";
import { Body } from "sunday-component";

export const StyledTooptipDesktopContainer = styled.div`
  @media only screen and (max-width: 1350px) {
    .ant-tooltip {
      display: none;
    }
  }
  .ant-tooltip-arrow {
    left: 83%;
    width: 30px;
  }
  .ant-tooltip-placement-bottom {
    padding-top: 6px;
  }
  .ant-tooltip-arrow-content {
    width: 14px;
    height: 14px;
  }
`;
export const TooltipContentContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const TooltipContentBody = styled(Body).attrs({ level: 7 })`
  color: ${color.white};
  margin-right: 8px;
`;

export const TooltipContentImage = styled.img`
  height: 24px;
  width: 24px;
  cursor: pointer;
`;
